import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WHAiChatComponent } from './components/wh-ai-chat.component';
import { AiStore } from './wh-ai.store';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'workheld-ai',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatTooltipModule,
    MatButtonModule,
    WHAiChatComponent,
    TranslateModule,
  ],
  styles: `
    .w-h-ai-toolbar {
      background: var(--wh-ai-primary);
      height: 64px;
      color: white;
      z-index: 2;
    }

    :host-context(.wh-ai-default-theme) .w-h-ai-toolbar {
      background: linear-gradient(
        118deg,
        var(--wh-ai-primary) 0%,
        var(--wh-ai-accent) 100%
      );
    }
  `,
  template: `
    <div class="flex--col">
      <mat-toolbar class="mat-elevation-z2 flex--r-c-sb w-h-ai-toolbar">
        <div class="flex--r-c gap--12">
          <mat-icon svgIcon="wh-ai-avatar"></mat-icon>
          <span>Workheld AI</span>
        </div>
        <div class="flex--r-c">
          <button
            data-cy="wh-ai-new-chat-button"
            [matTooltip]="'app.ai.newChat.button.tooltip' | translate"
            (click)="aiStore.resetSession()"
            mat-icon-button
          >
            <mat-icon>library_add</mat-icon>
          </button>
          <button
            data-cy="wh-ai-sessions-button"
            [matTooltip]="'app.ai.chats.button.tooltip' | translate"
            (click)="aiStore.toggleIsSessionHistoryActive()"
            mat-icon-button
          >
            <mat-icon>history</mat-icon>
          </button>
          <button
            data-cy="wh-ai-close-button"
            [matTooltip]="'app.close.label' | translate"
            (click)="handleCloseAiPanel()"
            mat-icon-button
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-toolbar>

      <app-wh-ai-chat />
    </div>
  `,
})
export class WorkheldAiComponent {
  aiStore = inject(AiStore);

  handleCloseAiPanel() {
    if (this.aiStore.isSessionHistoryActive()) {
      this.aiStore.toggleIsSessionHistoryActive();
    } else {
      this.aiStore.toggleAiActive();
    }
  }
}
